import React, { useState } from 'react';
import './Navbar.css';
import { FaRegBell } from 'react-icons/fa';
import { NavLink, useNavigate } from "react-router-dom";
import { routes } from "../routes/route";
import { Menu, MenuItem, IconButton, Popover, Box } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import FollowRequestCard from "./FollowRequestCard";
import { profiles } from "../data/ProfilesData";
import ApprovedNotificationCard from "./ApprovedNotificationCard";
import { useUser } from '../contexts/UserProvider';
import { auth } from '../firebase/firebase';
import CachedAvatar from './CachedAvatar';
import NotificationBell from './NotificationBell';


const Navbar = () => {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const [notifAnchorEl, setNotifAnchorEl] = useState(null);
    const isNotifOpen = Boolean(notifAnchorEl);
    const { profile, loading } = useUser();

    const handleAvatarClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleProfile = () => {
        handleClose();
        navigate('/profile');
    };

    // const handleBellClick = (event) => {
    //     setNotifAnchorEl(event.currentTarget);
    // };

    const handleNotifClose = () => {
        setNotifAnchorEl(null);
    };

    const handleLogout = async () => {
        sessionStorage.removeItem('isLoggedIn');
        await auth.signOut()
        handleClose();
        navigate('/login');
    };

    return (
        <nav className="nav">
            <div className="logo" onClick={() => navigate('/') } style={{ cursor: 'pointer' }}>
                <img src="/images/logo2.png" alt="YallaGo Logo" className="logo-img" />
            </div>


            <div className="links">
                {routes.map((route, index) => (
                    route.buttonText && (
                        <NavLink
                            className="link"
                            style={{ marginRight: 10 }}
                            to={route.path}
                            key={index}
                        >
                            <span className="icon">{route.icon}</span>
                            <span className="link-text">{route.buttonText}</span>
                        </NavLink>
                    )
                ))}
            </div>

            <div className="user">
                <NotificationBell />

                <IconButton onClick={handleAvatarClick} size="small" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    {!loading &&
                        <CachedAvatar src={profile.image} alt="user avatar" className="avatar" />
                    }
                    <KeyboardArrowDownIcon fontSize="small" style={{ color: '#555' }} />
                </IconButton>


                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    MenuListProps={{
                        className: 'profile-dropdown-menu',
                    }}
                >
                    <MenuItem onClick={handleProfile} className="dropdown-item">הפרופיל שלי</MenuItem>
                    <MenuItem onClick={handleLogout} className="dropdown-item">התנתק</MenuItem>
                </Menu>
            </div>
            <Popover
                open={isNotifOpen}
                anchorEl={notifAnchorEl}
                onClose={handleNotifClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <Box p={2} pt={4}>
                    <FollowRequestCard
                        profile={profiles[3]}
                        onApprove={() => {
                        }}
                        onDeny={() => {
                        }}
                    />

                    <ApprovedNotificationCard profile={profiles[2]} />
                </Box>
            </Popover>
        </nav>

    );
};

export default Navbar;
